module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/cap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ENERGIZE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Light, refreshing juices, packed with fruits and herbs that energize and kick-start your metabolism")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FUEL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Dense, filling, meal-like juices loaded with vitamins, fiber, and healthy fats")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DETOX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Detoxifying juices full of naturally cleansing vegetables, fruits, and whole raw spices")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PROTECT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Four")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Vitamin- and mineral-rich juices that help strengthen your immune system naturally")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0